import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import userReducer from "../slices/userSlice";
import tabsReducer from "../slices/tabsSlice";
import imagesReducer from "../slices/imagesSlices";
import equipamentosReducer from "../slices/equipamentosSlice";
import participantesReducer from "../slices/participantesSlice";
import analisesReducer from "../slices/analisesSlice";
import sidebarReducer from "../slices/sidebarSlice";
import mapaReducer from "../slices/mapaSlice";
import ucReducer from '../slices/ucSlice';

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const rootReducer = persistReducer(persistConfig, userReducer);

const store = configureStore({
  reducer: {
    user: rootReducer,
    tabs: tabsReducer,
    images: imagesReducer,
    participantes: participantesReducer,
    equipamentos: equipamentosReducer,
    analises: analisesReducer,
    sidebar: sidebarReducer,
    mapa: mapaReducer,
    uc: ucReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredPaths: ['tabs', 'participantes', 'equipamentos', 'analises']
      },
    }),
});

export let persistor = persistStore(store);
export default store;
//export type RootState = ReturnType<typeof store.getState>;
//export type AppDispatch = typeof store.dispatch;
